<template>
  <div class="pa-3 grey lighten-4">
    <v-card class="mt-3">
      <v-card-title class="grey lighten-4 pa-2">
        <h3 class="secondary--text">
          Payment Method
          <v-tooltip top color="white">
            <template v-slot:activator="{ on }">
              <v-icon size="19" v-on="on">mdi-information-outline</v-icon>
            </template>
            <span class="greyDarken3--text body-1"
              >Payment method that will be used in post payment
              transactions</span
            >
          </v-tooltip>
        </h3>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="onSave()" small>Save</v-btn>
      </v-card-title>
      <v-card-text>
        <!-- Payment Source -->
        <v-flex xs12 class="px-3">
          <ExistingPaymentMethod
            v-if="company.card_brand && company.card_last_four"
            class="my-3"
            :show_selected="false"
            :canEdit="userRoleInCompany >= DEFINES.ROLE_ADMIN"
            @onEdit="showPaymentMethodDialog"
          ></ExistingPaymentMethod>
          <v-layout v-else justify-center text-xs-center>
            <div class="greyDarken2--text pa-4">
              <div class="title">No payment method found</div>
              <div class="py-2">
                A default payment method will be added here on upgrading a
                screening
              </div>
            </div>
          </v-layout>
        </v-flex>
        <!-- Update payment method -->
        <v-layout v-if="editPymtMthdDialog" row justify-center>
          <v-dialog
            v-model="editPymtMthdDialog"
            persistent
            scrollable
            max-width="35vw"
          >
            <v-card>
              <v-card-title class="px-4">
                <div class="title">Update Payment Method</div>
                <v-spacer></v-spacer>
                <v-btn
                  class="mx-0 px-0"
                  small
                  dark
                  icon
                  color="grey"
                  @click="resetPaymentMethodDialog()"
                >
                  <v-icon small>$vuetify.icons.rms_close</v-icon>
                </v-btn></v-card-title
              >
              <v-divider></v-divider>
              <v-card-text style="max-height: 80vh" class="pa-4">
                <PaymentForm
                  :payment_method.sync="payment_method"
                  ref="paymentDetailForm"
                ></PaymentForm>
                <div class="greyDarken3--text">
                  <div class="pt-3">
                    <i>{{
                      $t("screener.upgrade.payment_method.instruction.1")
                    }}</i>
                  </div>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="grey"
                  dark
                  depressed
                  @click.stop="resetPaymentMethodDialog()"
                  >Cancel</v-btn
                >
                <v-btn
                  color="secondary"
                  dark
                  depressed
                  @click.stop="updatePaymentMethod()"
                  >Update</v-btn
                >
              </v-card-actions>
            </v-card>

          </v-dialog>
        </v-layout>
      </v-card-text>
    </v-card>
    <!-- Addons -->
    <v-card class="mt-3" v-if="selected_company_id && selected_company && !selected_company.is_screening_pricing_enterprise">
      <v-card-title class="grey lighten-4 pa-2">
        <h3 class="secondary--text">{{$t('manage_addons.title')}}</h3>
      </v-card-title>
      <v-card-text class="pa-5">
         <v-flex xs12 class="px-3">
          <v-layout justify-center text-xs-center>
            <AddOns :key="'add_on'"></AddOns>
          </v-layout>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import ExistingPaymentMethod from "@/components/ExistingPaymentMethod";
import { mapState, mapGetters } from "vuex";
import PaymentForm from "@/components/PaymentForm";
import AddOns from '@/components/screener/AddOns';
import rules from "@/validation";

export default {
  name: "CompanyConfig",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  components: {
    ExistingPaymentMethod,
    PaymentForm,
    AddOns
  },
  data() {
    return {
      rules,
      editPymtMthdDialog: false,
      payment_method: null
    };
  },

  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      selected_company: "getSelectedCompany",
    }),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
  },
  methods: {
    showPaymentMethodDialog() {
      this.editPymtMthdDialog = true;
    },
    resetPaymentMethodDialog() {
      this.editPymtMthdDialog = false;
      this.$refs.paymentDetailForm.reset();
    },
    async updatePaymentMethod() {
      try {
        if (!this.$refs.paymentDetailForm.validate()) {
          return false;
        }

        var payload = {};
        payload.payment_method = this.payment_method;
        await this.$store.dispatch("company/updatePaymentMethod", payload);
        this.resetPaymentMethodDialog();
        this.$store.dispatch("app/showMessage", {
          message:
            "Your default payment method has been updated successfully. This payment method will be used for future payments.",
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    onSave() {
      this.$emit("onSave", this.company);
    }
  },
};
</script>
